import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);
// import { API_URL, API_URL_SUFFIX } from "@/constants/api";
// import { extractProps } from "@/utils/api";
import { createFileRoute } from "@tanstack/react-router";
import Component from "@/routes/(inventory)/branch/_layout/sales_history/-components/component";
import {
  SalesHistorySearchParams,
} from "@/routes/(pharma)/_layout/overview/-data/schema";
import { Loading } from "@/layouts/loading";
import { ListSalesResponse } from "@/gen/sales/list_sales_pb";
import { pharmacyClient } from "@/connect";
import { SaleStatus, SalesUsers } from "@/gen/sales/common_pb";


export const Route = createFileRoute("/(inventory)/branch/_layout/sales_history/")({
  component: Component,
  validateSearch: SalesHistorySearchParams,
});
